"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Router_1 = require("./Router");
var es6_promise_1 = require("es6-promise");
es6_promise_1.polyfill();
var axios_1 = require("axios");
var Vapi = /** @class */ (function () {
    function Vapi(options) {
        this.config = {};
        this.getCryptedUrl = function (params) {
            var promise = {};
            promise = this.Http.get(Router_1.default.generate('api_media_get_crypted_player_string', typeof (params) === 'object' ? params : { v: params }));
            return promise;
        };
        this.baseURL = options.baseURL;
        this.tocken = options.tocken;
        this.Http = axios_1.default.create({
            baseURL: options.baseURL,
            headers: {
                Authorization: 'Bearer ' + options.tocken
            }
        });
        return this;
    }
    Vapi.prototype.setHeaders = function (idTheme, config) {
        this.config = config;
    };
    Vapi.prototype.getVideoByTheme = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', params));
        return promise;
    };
    Vapi.prototype.getVideosGroupedByTheme = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos_by_themes', params));
        return promise;
    };
    Vapi.prototype.getVideoInfoById = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video_info', { id: id }));
        return promise;
    };
    Vapi.prototype.getVideoMediUrl = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video_url', { id: id }));
        return promise;
    };
    Vapi.prototype.getLiveMediUrl = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_live_url', { id: id }));
        return promise;
    };
    Vapi.prototype.getVideoHomeByChannle = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_by_home_conf', params));
        return promise;
    };
    Vapi.prototype.getVideoHomeByLang = function (lang) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_by_home_conf', { lang: lang }));
        return promise;
    };
    Vapi.prototype.getVideoByWord = function (searchWord) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', { searchWord: searchWord }));
        return promise;
    };
    Vapi.prototype.getThemes = function (lang) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_for_mobile', { lang: lang }));
        return promise;
    };
    Vapi.prototype.getVideos = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos'));
        return promise;
    };
    Vapi.prototype.paginateVideos = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', params));
        return promise;
    };
    Vapi.prototype.paginateVideosAlaune = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', params));
        return promise;
    };
    Vapi.prototype.paginateHomeVideosByChannel = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_by_home_conf', params));
        return promise;
    };
    Vapi.prototype.getInfoPlayerPerId = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_player_infos', data));
        return promise;
    };
    Vapi.prototype.getCryptedPlaylistUrl = function (idPlaylist) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_crypted_player_playlist_string', { id: idPlaylist }));
        return promise;
    };
    Vapi.prototype.getVideoByWordAndLang = function (searchWord, lang) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', {
            searchWord: searchWord,
            lang: lang
        }));
        return promise;
    };
    Vapi.prototype.getVideoByFiltre = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos', filtre));
        return promise;
    };
    Vapi.prototype.getVideoHomeByFiltre = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_by_home_conf', filtre));
        return promise;
    };
    Vapi.prototype.contactMail = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_profiles_send_mail_since_contact_form'), {
            "message": data.message,
            'username': data.username
        });
        return promise;
    };
    Vapi.prototype.errorLog = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_log'), {
            "cause": data.cause,
            "module": data.module,
            "error_code": data.error_code,
            "exception": data.error_exception
        });
        return promise;
    };
    Vapi.prototype.login = function (credentials) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_subscription_user_authentification'), credentials, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.sendSuccessQuiz = function (params) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_mooc_add_certificate'), params, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getDataStatsMooc = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_mooc_get_stats_options'));
        return promise;
    };
    Vapi.prototype.subscribeUser = function (params) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_subscription_user_subscription_mail'), params, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getIntranetInformation = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_subscription_user_get_ip_intranet'), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getStatsVideosByTheme = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_mooc_get_stats_videos_by_themes', { idTheme: params.idTheme, idUser: params.idUser }), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getQuizByThemes = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_quiz_by_theme', { id: params.id }), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.progressionPasseportByUser = function (user) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_mooc_post_mooc_number_passeport_by_user'), user, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.progressionVisaByUser = function (user) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_mooc_post_mooc_number_visa_by_user'), user, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.lastResponseBeforeDestroy = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_mooc_post_last_response_before_destroy'), data, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.subscribeNewUser = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_subscription_user_post_add_user'), data, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.initPassword = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_subscription_user_post_subscription_mail_pwd'), data, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.newPassword = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_subscription_user_post_change_pwd'), data, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getListVideoOnGoingCustom = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos_all_custom', data));
        return promise;
    };
    Vapi.prototype.getVideoById = function (idVideo) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video', { id: idVideo }));
        return promise;
    };
    Vapi.prototype.getThemeVideoById = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video_custom', params));
        return promise;
    };
    Vapi.prototype.getThemesSubThemesList = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_children'));
        return promise;
    };
    Vapi.prototype.getInfosProfileUser = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_mooc_get_infos_profile_user', params));
        return promise;
    };
    Vapi.prototype.getListOngoingVideosCustom = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_on_going_videos_custom', params));
        return promise;
    };
    Vapi.prototype.getListThemesPerChannel = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_children_per_canal', params));
        return promise;
    };
    Vapi.prototype.getMOOCListThemesPerChannel = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_mooc_get_stats_themes_by_channels', params));
        return promise;
    };
    Vapi.prototype.getQuizByThemesParent = function (params) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_list_quiz_by_theme_parent', { id: params.id }), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.postAddQuizResponses = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_add_quiz_responses'), data, { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getLatestNew = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_news_get_latest_news'));
        return promise;
    };
    Vapi.prototype.getCryptedUrlByToken = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_crypted_player_string_custom', data));
        return promise;
    };
    Vapi.prototype.getDataCryptedUrlByToken = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_decrypted_infos', data));
        return promise;
    };
    Vapi.prototype.getOngoingVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos_ongoing', filtre));
        return promise;
    };
    Vapi.prototype.getArchivedVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos_archived', filtre));
        return promise;
    };
    Vapi.prototype.getUpComingVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos_upcoming', filtre));
        return promise;
    };
    Vapi.prototype.getAllVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos', filtre));
        return promise;
    };
    Vapi.prototype.getOffLineVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos_offline', filtre));
        return promise;
    };
    Vapi.prototype.getArchivedExceedVideos = function (filtre) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_dtable_list_dtable_videos_exceed', filtre));
        return promise;
    };
    Vapi.prototype.getParamListVideo = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_params_url_list_video', data) + "?time=" + Date.now());
        return promise;
    };
    Vapi.prototype.getListChannelsGroupByThemes = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_channels_group_by_themes', data));
        return promise;
    };
    Vapi.prototype.getListChannels = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_channels_names', data));
        return promise;
    };
    Vapi.prototype.getListThemes = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_names', data));
        return promise;
    };
    Vapi.prototype.getListContributors = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_contributors', data));
        return promise;
    };
    Vapi.prototype.deleteSelectedVideos = function (data) {
        var promise = {};
        promise = this.Http.delete(Router_1.default.generate('api_multi_delete_videos', data));
        return promise;
    };
    Vapi.prototype.getListPermission = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_core_rights_get_user_rights', data));
        return promise;
    };
    Vapi.prototype.getListStatsVideos = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_number_visits', data));
        return promise;
    };
    Vapi.prototype.getTranscodedVideos = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_check_if_videos_are_done_transoding'), data);
        return promise;
    };
    Vapi.prototype.enablePushVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_enable_push_video', data));
        return promise;
    };
    Vapi.prototype.disablePushVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_disable_push_video', data));
        return promise;
    };
    Vapi.prototype.addVideoToHomePage = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_add_home_page_video', data));
        return promise;
    };
    Vapi.prototype.removeVideoFromHomePage = function (data) {
        var promise = {};
        promise = this.Http.delete(Router_1.default.generate('api_media_delete_home_page_video', data));
        return promise;
    };
    Vapi.prototype.toggleOfflineOnlineVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_toggle_video_by_type'), data);
        return promise;
    };
    Vapi.prototype.deleteVideo = function (data) {
        var promise = {};
        promise = this.Http.delete(Router_1.default.generate('api_media_delete_video', data));
        return promise;
    };
    Vapi.prototype.archivateVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_archivate_video', data));
        return promise;
    };
    Vapi.prototype.archivateVideos = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_archivate_videos'), data);
        return promise;
    };
    Vapi.prototype.restoreVideo = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_restore_video', data));
        return promise;
    };
    Vapi.prototype.getThemeDetailById = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_detail_theme', { id: id }), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.getThemesByData = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_for_mobile', data));
        return promise;
    };
    Vapi.prototype.getThemesWithChildrenByData = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_with_children', data));
        return promise;
    };
    Vapi.prototype.getThemesWithChildren = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_with_children'));
        return promise;
    };
    Vapi.prototype.getSocialMediaLinks = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_links_social_medias'));
        return promise;
    };
    Vapi.prototype.getRelatedVideos = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_associated_videos', data));
        return promise;
    };
    Vapi.prototype.getMostVisitedVideos = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_most_visited', data));
        return promise;
    };
    Vapi.prototype.getCurrentLive = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_get_current_live', data));
        return promise;
    };
    Vapi.prototype.checkLive = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_check_existence_live_today'));
        return promise;
    };
    Vapi.prototype.getDetailLive = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_get_lives_live_detail', data));
        return promise;
    };
    Vapi.prototype.getThemesListForSelectInput = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_parameters_get_themes_choices_for_select_input', data));
        return promise;
    };
    Vapi.prototype.sendStatAcces = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_stats_acces_post_add_stats_acces'), data);
        return promise;
    };
    Vapi.prototype.getStreamDetailLive = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_get_live_detail_by_stream_name', data));
        return promise;
    };
    Vapi.prototype.getStreamLiveMediUrl = function (streamName) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_getlink_export_by_stream_name', { streamName: streamName }));
        return promise;
    };
    Vapi.prototype.getListPDF = function () {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_get_list_pdf'));
        return promise;
    };
    Vapi.prototype.saveSsettingVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_save_setting_video'), data);
        return promise;
    };
    Vapi.prototype.saveSkinVideo = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_post_set_default_skin_video'), data);
        return promise;
    };
    Vapi.prototype.getCurrentSkin = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_params_get_detail_param', data));
        return promise;
    };
    Vapi.prototype.getPreviewLinkByToken = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video_preview_link_by_token', data));
        return promise;
    };
    Vapi.prototype.getUserParams = function (cryptext) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_get_user_params', { cryptext: cryptext }));
        return promise;
    };
    Vapi.prototype.updateVote = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_post_vote_by_user_and_video'), data);
        return promise;
    };
    Vapi.prototype.getAverageVote = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_post_average_and_number_user_vote_video'), data);
        return promise;
    };
    Vapi.prototype.getVideoDownload = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_download_video', { id: id }));
        return promise;
    };
    Vapi.prototype.getLinkVideo = function (id) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_video_preview_link', { id: id, y: 'bo' }));
        return promise;
    };
    Vapi.prototype.contactUs = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_contact_us'), data);
        return promise;
    };
    Vapi.prototype.updateService = function (options) {
        var headers = {
            Authorization: 'Bearer ' + this.tocken
        };
        if (options.idUser) {
            headers['Authorization'] = 'Bearer ' + options.idUser;
        }
        if (options.client) {
            headers['X-Tenant-ID'] = options.client;
        }
        if (options.user) {
            headers['X-Tenant-USER'] = options.user;
        }
        this.Http = axios_1.default.create({
            baseURL: this.baseURL,
            headers: headers
        });
        return this;
    };
    Vapi.prototype.verifTokenVideo = function (token) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_exist_token_video', { token: token }), { emulateJSON: true });
        return promise;
    };
    Vapi.prototype.sendMail = function (params) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_media_send_video_by_id_via_mail'), params);
        return promise;
    };
    Vapi.prototype.createWebinar = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_post_add_edit_event_calendar'), data);
        return promise;
    };
    Vapi.prototype.sendContactMail = function (data) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_ws_contact_send_mail_since_contact_form_f_o'), data);
        return promise;
    };
    Vapi.prototype.writeLogs = function (message) {
        var promise = {};
        promise = this.Http.post(Router_1.default.generate('api_write_log'), message);
        return promise;
    };
    Vapi.prototype.verifTokenFo = function (token) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_verif_secure_token_fo', { token: token }));
        return promise;
    };
    Vapi.prototype.getMostLikedVideos = function (data) {
        var promise = {};
        promise = this.Http.get(Router_1.default.generate('api_media_get_videos_most_liked', data));
        return promise;
    };
    return Vapi;
}());
exports.Vapi = Vapi;
exports.default = Vapi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-service-api/dist/index.js
// module id = VMx2
// module chunks = 0